import { Box, styled } from "@mui/material";
import FlexBox from "components/flexbox/FlexBox";
import Scrollbar from "components/ScrollBar";
import LayoutDrawer from "layouts/layout-parts/LayoutDrawer";
import MultiLevelMenu from "./MultiLevelMenu";
import { useEffect, useState } from "react";
import API from "services/api";
import StaticVar from "config/StaticVar";
const TOP_HEADER_AREA = 70;
const NavWrapper = styled(Box)(() => ({
  paddingLeft: 16,
  paddingRight: 16,
  height: "100%",
}));
const StyledLogo = styled(Box)(() => ({
  paddingLeft: 8,
  fontWeight: 700,
  fontSize: 20,
}));

const MobileSidebar = (props) => {
  const { sidebarCompact, showMobileSideBar, setShowMobileSideBar, menu } = props;
  const [appConfig, setAppConfig] = useState(null);

  useEffect(() => {
    const fetchAppConfig = async () => {
      try {
        const response = await API.getAppConfig();
        setAppConfig(response.data);
      } catch (error) {
        console.error("Gagal memuat konfigurasi:", error);
      }
    };

    fetchAppConfig();
  }, []);
  return (
    <LayoutDrawer open={showMobileSideBar} onClose={setShowMobileSideBar}>
      <Box p={2} maxHeight={TOP_HEADER_AREA}>
        <FlexBox ml={1.5} alignItems="center">
          <img
            src={`${StaticVar.URL_API}${appConfig?.logoUrl}`}
            alt={`Logo ${appConfig?.title}`}
            width={50}
            height={50}
          />
          <StyledLogo>{appConfig?.title}</StyledLogo>
        </FlexBox>
      </Box>

      <Scrollbar
        autoHide
        clickOnTrack={false}
        sx={{
          overflowX: "hidden",
          maxHeight: `calc(100vh - ${TOP_HEADER_AREA}px)`,
        }}
      >
        <NavWrapper compact={sidebarCompact}>
          <MultiLevelMenu sidebarCompact={false} menu={menu} />
        </NavWrapper>
      </Scrollbar>
    </LayoutDrawer>
  );
};

export default MobileSidebar;
